(function () {
  function initDropdown(el, onChange) {
    var trigger = el.querySelector('.fym__dropdown-trigger');
    var valueEl = el.querySelector('.fym__dropdown-value');
    var options = el.querySelectorAll('.fym__dropdown-option');
    var current = '';

    function open() {
      var root = el.closest('[data-find-your-match]');
      if (root) {
        root.querySelectorAll('.fym__dropdown.is-open').forEach(function (other) {
          if (other !== el) {
            other.classList.remove('is-open');
            var t = other.querySelector('.fym__dropdown-trigger');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
      }
      el.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      el.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function select(value, label) {
      current = value;
      valueEl.textContent = label;
      options.forEach(function (opt) {
        opt.classList.toggle('is-selected', opt.getAttribute('data-value') === value);
      });
      close();
      onChange(value);
    }

    trigger.addEventListener('click', function (e) {
      e.stopPropagation();
      el.classList.contains('is-open') ? close() : open();
    });

    options.forEach(function (opt) {
      opt.addEventListener('click', function (e) {
        e.stopPropagation();
        select(opt.getAttribute('data-value'), opt.textContent.trim());
      });
    });

    document.addEventListener('click', function (e) {
      if (!el.contains(e.target)) close();
    });

    return { getValue: function () { return current; } };
  }

  function init(root) {
    var dataEl = root.querySelector('[data-fym-data]');
    var lensEl = root.querySelector('[data-fym-lens]');
    var templeEl = root.querySelector('[data-fym-temple]');
    var resultsEl = root.querySelector('[data-fym-results]');
    if (!dataEl || !lensEl || !templeEl || !resultsEl) return;

    var products = [];
    try { products = JSON.parse(dataEl.textContent) || []; } catch (e) { products = []; }

    var cards = {};
    root.querySelectorAll('[data-fym-card]').forEach(function (el) {
      cards[String(el.getAttribute('data-product-id'))] = el;
    });

    var swiper = null;
    var wrapperEl = resultsEl.querySelector('.swiper-wrapper');
    var prevEl = root.querySelector('[data-fym-prev]');
    var nextEl = root.querySelector('[data-fym-next]');
    var mediaQuery = window.matchMedia('(max-width: 768px)');
    var currentMatchCount = 0;
    var stashEl = document.createElement('div');
    stashEl.hidden = true;
    root.appendChild(stashEl);

    function measurementMatches(value, selected) {
      if (selected === '') return true;
      if (value === null || value === undefined) return false;
      var productValue = toNumber(value);
      var selectedValue = toNumber(selected);
      if (isNaN(productValue) || isNaN(selectedValue)) return false;
      return Math.abs(productValue - selectedValue) <= 2;
    }

    function toNumber(value) {
      if (typeof value === 'number') return value;
      var normalized = String(value).replace(',', '.').replace(/[^\d.-]/g, '');
      return normalized === '' || normalized === '-' || normalized === '.' ? NaN : Number(normalized);
    }

    function getNavigationThreshold() {
      return mediaQuery.matches ? 2 : 4;
    }

    function setNavigationVisibility(matchCount) {
      if (!prevEl || !nextEl) return;
      var shouldHide = typeof Swiper === 'undefined' || matchCount < getNavigationThreshold();
      prevEl.hidden = shouldHide;
      nextEl.hidden = shouldHide;
    }

    function update() {
      var lens = lensDropdown.getValue();
      var temple = templeDropdown.getValue();
      if (swiper) { swiper.destroy(true, true); swiper = null; }

      var matchCount = 0;

      products.forEach(function (p) {
        var card = cards[String(p.id)];
        if (!card) return;
        var matches = measurementMatches(p.lens, lens) && measurementMatches(p.temple, temple);
        if (matches) {
          card.hidden = false;
          card.style.display = '';
          wrapperEl.appendChild(card);
          matchCount++;
        } else {
          card.hidden = true;
          card.style.display = 'none';
          stashEl.appendChild(card);
        }
      });

      currentMatchCount = matchCount;
      setNavigationVisibility(matchCount);

      if (matchCount === 0) {
        resultsEl.hidden = true;
        return;
      }

      resultsEl.hidden = false;
      initSwiper();
    }

    function initSwiper() {
      if (typeof Swiper === 'undefined') return;
      swiper = new Swiper(resultsEl.querySelector('.swiper'), {
        slidesPerView: 2,
        spaceBetween: 12,
        loop: false,
        navigation: {
          nextEl: nextEl,
          prevEl: prevEl
        },
        breakpoints: {
          769: { slidesPerView: 3 },
          1201: { slidesPerView: 4 }
        }
      });
    }

    var lensDropdown = initDropdown(lensEl, update);
    var templeDropdown = initDropdown(templeEl, update);

    update();

    function handleNavigationBreakpointChange() {
      setNavigationVisibility(currentMatchCount);
      if (swiper) swiper.update();
    }

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleNavigationBreakpointChange);
    } else if (mediaQuery.addListener) {
      mediaQuery.addListener(handleNavigationBreakpointChange);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-find-your-match]').forEach(init);
  });
})();
